import React from 'react';

/**
 * Vertical timeline with continuous left rail and circular pin per day block.
 * Renders the `program_days` array stored on each course (extracted from the
 * official Qualiopi PDF). Pure presentational component — no data fetching.
 */
export const ProgramTimeline = ({ days = [] }) => {
  if (!days?.length) return null;

  return (
    <div className="relative" data-testid="program-timeline">
      {/* Continuous vertical rail */}
      <div
        aria-hidden="true"
        className="absolute left-[19px] md:left-[27px] top-2 bottom-2 w-px bg-gradient-to-b from-[#C9B896]/40 via-[#1F2A4A]/15 to-[#C9B896]/40"
      />

      <ol className="space-y-10 md:space-y-12">
        {days.map((d, idx) => (
          <li
            key={`${d.label}-${idx}`}
            className="relative pl-14 md:pl-20 group"
            data-testid={`program-day-${idx}`}
          >
            {/* Pin */}
            <div className="absolute left-0 top-1.5 flex items-center justify-center w-10 md:w-14 h-10">
              <span
                aria-hidden="true"
                className="block w-3.5 h-3.5 rounded-full bg-[#C9B896] ring-4 ring-[#FAF7F0] shadow-[0_0_0_1px_rgba(31,42,74,0.18)] group-hover:scale-125 group-hover:bg-[#1F2A4A] transition-all duration-500"
              />
            </div>

            <p className="text-[10px] md:text-xs font-mono tracking-[0.32em] text-[#C9B896] mb-2 uppercase">
              {d.label}
            </p>

            {d.title && (
              <h3 className="font-serif text-xl md:text-2xl text-[#1F2A4A] font-light leading-snug mb-3 md:mb-4">
                {d.title}
              </h3>
            )}

            {d.bullets?.length > 0 && (
              <ul className="space-y-2 text-[#4A5568] text-sm md:text-base font-light leading-relaxed">
                {d.bullets.map((b, j) => (
                  <li
                    key={j}
                    className="relative pl-5 before:content-[''] before:absolute before:left-0 before:top-[0.65em] before:w-2 before:h-px before:bg-[#C9B896]"
                  >
                    {b}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default ProgramTimeline;
